import { Record } from 'immutable';

export default class InternalTimeReport extends Record({
  bookedPeriods: undefined,
  bookingInvoiceItems: undefined,
  bookingPaymentItems: undefined,
  bookings: undefined,
  customerAttests: undefined,
  mileageAllowances: undefined,
  reportedPeriods: undefined,
  resources: undefined,
  timeReports: undefined,
}) {
}
